import Vue from 'vue'
import Vuex from 'vuex'
import i18n from './i18n'
import VueLocalStorage from 'vue-localstorage';

Vue.use(VueLocalStorage);
Vue.use(Vuex);

export default new Vuex.Store({
/*     modules: {
        i18n: vuexI18n.store,
        language,
    }, */
 /*    messages: loadLocaleMessages(), */
    state: {
        showform: true,
        count: 1,
        carousel: [
            {
                name: 'filmAutomatic',
                src: 'film-estirable-automatic.jpg',
                link: '/consumibles/film-estirable-automatic'
            },
            {
                name: 'filmManual',
                src: 'film-estirable.jpg',
                link: '/consumibles/film-estirable-manual'
            },/* 
            {
                name: 'filmPreestirat',
                src: 'film-estirable-automatic.jpg',
            }, */
            {
                name: 'cintesAdhesives',
                src: 'cinta-adhesiva-packetgrup.jpg',
                link: '/consumibles/cintes-adhesives'
            },
            {
                name: 'Cintes adhesives personalitzades',
                src: 'cintes-personalitzades.jpg',
                link: '/consumibles/cintes-adhesives-impreses'
            },
            {
                name: 'cintesCreppe',
                src: 'cintes-creppe.jpg',
                link: '/consumibles/cintes-creppe'
            },
            {
                name: 'cintesTramades',
                src: 'cintes-tramades.jpg',
                link: '/consumibles/cintes-tramades'
            },
            {
                name: 'precintesSeguretat',
                src: 'precintes-seguretat.jpg',
                link: '/consumibles/precintes-seguretat'
            },
            {
                name: 'flejes',
                src: 'flejes-packetgrup.jpg',
                link: '/consumibles/flejes'
            },
            {
                name: 'cintesRibbon',
                src: 'cintes-ribbon.jpg',
                link: '/consumibles/cintes-ribbon'
            },
            {
                name: 'farcimentPorex',
                src: 'farciment-porex.jpg',
                link: '/consumibles/farciment-porex'
            },
            {
                name: 'etiquetesAdhesives',
                src: 'etiquetes-adhesives.jpg',
                link: '/consumibles/etiquetes-adhesives'
            },
            {
                name: 'cantoneresCartro',
                src: 'cantoneres-cartro.jpg',
                link: '/consumibles/cantoneres-cartro'
            },
            {
                name: 'precintadora',
                src: 'precintadora.jpg',
                link: '/maquinaria/precintadores'
            },
            {
                name: 'farciment',
                src: 'farciment-paper.jpg',
                link: '/consumibles/farciment-porex'
            },
            {
                name: 'flexadora',
                src: 'flexadora.jpg',
                link: '/maquinaria/flexadores'
            },
        ],
        menu: [
            {
                path: '/',
                name: 'Packet Grup',
                icon: 'mdi-package-variant-closed',
                color: 'grey',
                counter: 0,
            },
            {
                path: '/consumibles',
                name: 'Consumibles',
                icon: 'mdi-circle-double',
                color: '#df7606',
                counter: 0,
                children: [
                    {
                        title: "FILMS",
                        path: `/${i18n.locale}`+ "/consumibles/film-estirable-automatic",
                        name: "Film estirable automàtic",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/film-estirable-manual",
                        name: "Film estirable manual",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/films-preestirats",
                        name: "Films pre-estirats",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/lamina-polietile-PE",
                        name: "Làmina polietilè PE" ,
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/cobre-palets",
                        name: "Cobre palets",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/funda-palet",
                        name: "Funda palets",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/bandita",
                        name: "Bandita",
                        counter: 0,
                    }
                ],
                children2: [
                    {
                        title: "PRECINTES",
                        path: `/${i18n.locale}`+ "/consumibles/cintes-adhesives",
                        name: "Cintes adhesives",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/cintes-adhesives-impreses",
                        name: "Cintes adhesives impreses",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/cintes-creppe",
                        name: "Cintes Creppe",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/cintes-tramades",
                        name: "Cintes tramades",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/precintes-seguretat",
                        name: "Precintes de seguretat",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/flejes",
                        name: "Fleixos",
                        counter: 0,
                    },
                    {          
                        path: `/${i18n.locale}`+ "/consumibles/cintes-ribbon",
                        name: "Cintes Ribbon",
                        counter: 0,
                        text: "Cintes Ribbon."
                    }
                ],
                children3: [
                    {
                        title: "CONSUMIBLES",
                        path: `/${i18n.locale}`+ "/consumibles/bosses-aire",
                        name: "Bosses d'aire",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/cartro-ondulat",
                        name: "Cartró ondulat",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/plastic-bombolla",
                        name: "Plàstic bombolla",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/bobines-foam",
                        name: "Bobines FOAM",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/cantoneres-foam",
                        name: "Cantoneres FOAM",
                        counter: 0,
                    },
                    {
                       path: `/${i18n.locale}`+ "/consumibles/sobres-packing-list",
                        name: "Sobres Packing list",
                        counter: 0,
                    }, 
                    {
                        path: `/${i18n.locale}`+ "/consumibles/bosses-mini-grip",
                        name: "Bosses mini-grip",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/sobres-paper-bombolla",
                        name: "Sobres paper bombolla",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/etiquetes-adhesives",
                        name: "Etiquetes adhesives",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/etiquetes-adr",
                        name: "Etiquetes ADR",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/cantoneres-cartro",
                        name: "Cantoneres cartró",
                        counter: 0,
                    },
                    {
                        path: `/${i18n.locale}`+ "/consumibles/paper-kraft",
                        name: "Paper KRAFT",
                        counter: 0,
                    },
                    {          
                        path: `/${i18n.locale}`+ "/consumibles/farciment-porex",
                        name: "Farciment porex",
                        counter: 0,
                    }
                ],
                
            },
            {
                path: '/maquinaria',
                name: 'Maquinària',
                icon: 'mdi-seat',
                color: '#059d8a',
                counter: 0,
                children: [
                    {      
                        name: "Enfardadores",
                        path: `/${i18n.locale}`+ "/maquinaria/enfardadores",
                        counter: 0,
                    },
                    { 
                        name: "Precintadores",
                        path: `/${i18n.locale}`+ "/maquinaria/precintadores",
                        counter: 0,
                    },
                    { 
                        name: "Flexadores manuals i automàtiques",
                        path: `/${i18n.locale}`+ "/maquinaria/flexadores",
                        counter: 0,
                    },
               /*      { 
                        name: "Formadores de caixes",
                        path: `/${i18n.locale}`+ "/maquinaria/formadores-caixes",
                        counter: 0,
                    }, */
                 /*    { 
                        name: "Manipuladores de caixes",
                        path: `/${i18n.locale}`+ "/maquinaria/manipuladores-caixes",
                        counter: 0,
                    }, */
                    { 
                        name: "Carros porta fleixos",
                        path: `/${i18n.locale}`+ "/maquinaria/porta-fleixos",
                        counter: 0,
                    }
                ]
            },
            {
                path: '/eco-productes',
                name: 'Eco-productes',
                icon: 'mdi-leaf',
                color: '#8ff46d',
                counter: 0,
                children: [
                    {
                        name: "Sobres packing list paper",
                        path: `/${i18n.locale}/eco-productes/sobres-packing-list-paper`,
                        counter: 0,
                    },
                    { 
                        name: "Nano films",
                        path: `/${i18n.locale}`+"/eco-productes/nano-films",
                        counter: 0,
                    },
                    { 
                        name: "Cantoneres FOAM reciclades",
                        path: `/${i18n.locale}`+"/eco-productes/contaneres-foam-reciclades",
                        counter: 0,
                    },
                    { 
                        name: "Cintes Kraft",
                        path: `/${i18n.locale}`+"/eco-productes/cintes-kraft",
                        counter: 0,
                    },
                    { 
                        name: "Palespan biodegradable",
                        path: `/${i18n.locale}`+"/eco-productes/palespan-biodegradable",
                        counter: 0,
                    },
                    { 
                        name: "Farciment de paper",
                        path: `/${i18n.locale}`+"/eco-productes/farciment-paper",
                        counter: 0,
                    }
                ]
            },
            {
                path: `/${i18n.locale}` + '/contacte',
                name: 'Contacte',
                icon: 'mdi-email',
                color: '#EA5F08 ',
                counter: 0,
            },
        ],
        counters: [],
    },
    mutations: {
        increment: state => state.count++,
        decrement: state => state.count--,
        handleform (state) {
            state.showform = !state.showform
        },
        counters: state => state.counters++,

        changeLanguage: (state, response) => {
            if(response) {
                state.currentLanguage = response;
            }
        },
    },
    actions: {
/*         changeLanguage (context) {
            context.commit('changeLanguage')
        }, */
        getValue (value) {
            value.commit('handlevalue')
        },
 /*        changeLanguage (context, payload) {
            context.commit('changeLanguage')
            payload.i18n.locale = payload.lang
        }, */
/*         changeLanguage (context, payload) {
            context.commit('changeLanguage')
            payload.i18n.locale = payload.lang
        }, */
        changeLanguage(lang) {
            Vue.i18n.set(lang);
            this.selectedLanguage = lang;
            this.$store.commit('changeLang', lang);
        }
    },
    getters: {
        navmenu: state => {
            return state.navmenu
        },
        getLanguage: state => {
            return state.language
        },
    }
})
/* Vue.use(vuexI18n.plugin, store); */
